export default __webpack_public_path__ + "static/image-bolt-cce644a09f7fa4e2637af414061cdf91.png";